import React, { Component } from 'react';
import { withRouter } from 'react-router';

class ScrollToTop extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }
  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)


/** WEBPACK FOOTER **
 ** ./src/components/ScrollToTop.js
 **/